import type { ApiStudyProgramme, ApiStudyProgrammeGroup } from '../../types/samApiTypes';

export const getGradeForStudyProgramme = (
  fullStudyProgram: ApiStudyProgramme | undefined,
  allGrades: ApiStudyProgrammeGroup[],
): ApiStudyProgrammeGroup | undefined => {
  if (!fullStudyProgram) return undefined;
  if (!allGrades.length) return undefined;

  const groups = fullStudyProgram.studyProgrammeGroups.map((z) => z.studyProgrammeGroup.href);

  const grade = allGrades.find((e) => groups.includes(e.$$meta.permalink));
  return grade;
};
